
export class MemoryMonitor {
  constructor(interval = 5000) {
    this.interval = interval;
    this.timer = null;
    this.peakMemory = 0;
  }

  start() {
    this.timer = setInterval(() => {
      this.checkMemory();
    }, this.interval);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  checkMemory() {
    if (performance && performance.memory) {
      const memory = performance.memory;
      const usedMB = memory.usedJSHeapSize / (1024 * 1024);
      const totalMB = memory.totalJSHeapSize / (1024 * 1024);
      const limitMB = memory.jsHeapSizeLimit / (1024 * 1024);

      this.peakMemory = Math.max(this.peakMemory, usedMB);

      // console.log('Memory Usage:', {
      //   used: `${usedMB.toFixed(2)} MB`,
      //   total: `${totalMB.toFixed(2)} MB`,
      //   limit: `${limitMB.toFixed(2)} MB`,
      //   peak: `${this.peakMemory.toFixed(2)} MB`,
      //   usagePercent: `${((usedMB / limitMB) * 100).toFixed(1)}%`
      // });

      var momeryBall = (()=>{
        var momeryBall = document.getElementById('momeryBall')
        if(!momeryBall){
          momeryBall = document.createElement('div')
          momeryBall.id = 'momeryBall'
          document.body.appendChild(momeryBall)
        }


        return momeryBall
      })()

      var percent = `${((usedMB / limitMB) * 100).toFixed(1)}`
      momeryBall.innerHTML = `${percent}%`

      if(percent < 50){
        momeryBall.style.backgroundColor = 'green'
      }else if(percent < 70 && percent >= 50){
        momeryBall.style.backgroundColor = 'orange'
      }else{
        momeryBall.style.backgroundColor = 'red'
      }




      // 警告阈值（例如80%）
      if ((usedMB / limitMB) > 0.8) {
        console.warn('内存使用超过80%！');
      }
    }
  }

  // 手动触发垃圾回收（Chrome特定）
  forceGC() {
    if (window.gc) {
      window.gc();
    } else if (global.gc) {
      global.gc();
    }
  }
}





